import * as React from 'react';
import {useEffect, useMemo, useState} from 'react';
import BottomCompareItemSlider from './BottomCompareItemSlider';
import BottomCompareActions from './BottomCompareActions';
import ProductCompareRepository from "../../../repository/ProductCompareRepository";
import {useSelector} from "react-redux";

const ProductCompareMiniSlider = (props) => {
    const compareProductList = useSelector((state) => state.entities.model_ProductCompare.data);
    const [firstServerCall, setFirstServerCall] = useState(true);

    useEffect(() => {
        async function fetchHere() {
            await new ProductCompareRepository().fetchAllData();
            setFirstServerCall(false)
        }

        if (firstServerCall === true) {
            fetchHere()
        }
    }, []);
    const channel = useMemo(() => new BroadcastChannel('product-compare-toggled'), []);
    channel.addEventListener('message', async () => {
        await new ProductCompareRepository().fetchAllData();
    });
    return (
        <>
            {compareProductList && Object.keys(compareProductList).length > 0 &&
            <div className="copmare-items-bottom-list position-fixed start-0">
                <div className="container-fluid maxw100">
                    <div className="bs5 row">
                        {props.hideCompareSlider != undefined && props.hideCompareSlider ? '' : <>
                            <BottomCompareItemSlider/> <BottomCompareActions/></>}
                    </div>
                </div>
            </div>
            }
        </>
    );
}

export default ProductCompareMiniSlider;